<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lvM1cV/tc-custom/9781449460945.jpg?1712901123774" alt="This image is the cover for the book Preserving the Japanese Way"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Preserving the Japanese Way
      </h1>
      <p class="bookDescription body article font2">
        <b>This beautifully illustrated guide by the author of <i>Japanese Farm Food</i> includes essential Japanese pantry tips and 125 recipes. </b><br/><br/>In <i>Preserving the Japanese Way</i>, Nancy Singleton Hachisu offers step-by-step instructions for preserving fruits, vegetables, and fish using the age-old methods of Japanese farmers and fishermen. The recipes feature ingredients easily found in grocery stores or Asian food markets, such as soy sauce, rice vinegar, sake, and koji. <br/><br/>Recipes range from the ultratraditional— <i>Umeboshi</i> (Salted Sour Plums), <i>Takuan</i> (Half-Dried Daikon Pickled in Rice Bran), and <i>Hakusai </i>(Fermented Napa Cabbage)— to modern creations like Zucchini Pickled in Shoyu Koji, Turnips Pickled with Sour Plums, and Small Melons in Sake Lees. <br/><br/>Hundreds of full-color photos offer a window into the culinary life of Japan, from barrel makers and fish sauce producers to traditional morning pickle markets. More than a simple recipe book, <i>Preserving the Japanese Way</i> is a book about community, seasonality, and ultimately about why both are relevant in our lives today.<br/><br/><b>“This is a gorgeous, thoughtful—dare I say spiritual—guide to the world of Japanese pickling written with clarity and a deep respect for technique and tradition.” —Rick Bayless, author of <i>Authentic Mexican</i> and owner of Frontera Grill</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nancy Singleton Hachisu, David Tanis
      </h2>
      
      <p class="authorDescription body article">Native Californian Nancy Singleton Hachisu has lived with her Japanese farmer husband and three sons in their traditional Japanese farmhouse for the last 27 years in rural Japan, where she served as leader of a local Slow Food convivium for more than a decade. Her first book, Japanese Farm Food (Andrews McMeel, September 2012), was praised in the New York Times, London Times, the LA Times and more. TBS and Fuji TV are currently documenting Hachisu's preserving and farm food life in rural Saitama as well as her visits to artisanal producers in more remote areas of Japan.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1f1b2845